// extracted by mini-css-extract-plugin
module.exports = {"container":"grossprofit_container__34tiQ","tooltip":"grossprofit_tooltip__1RCVY","text":"grossprofit_text__IOTGp"};